import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 51rem;

  @media (max-width: 768px) {
    width: 100%;
  }

  > .MuiFormControl-root {
    margin-bottom: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }
`;

export const ContainerClear = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 1.2rem;

  > div:nth-child(1) {
    margin-right: 1rem;
  }
`;
